module.exports = __webpack_public_path__ + "media/images/meta/stride/favicon-fa38b19324b03f8cf0477712a62866f3.png";